var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "dark-graph"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tab-graph"
  }, [_c('div', {
    staticClass: "tbGraph-btn d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.tabTitle))])]), _c('div', [_c('ul', {
    staticClass: "nav nav-pills",
    attrs: {
      "id": "pills-tab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item",
    attrs: {
      "role": "presentation"
    }
  }, [_c('button', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab === 'power'
    },
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "pills-home-tab",
      "data-bs-toggle": "pill",
      "data-bs-target": "#pills-home",
      "type": "button",
      "role": "tab",
      "aria-controls": "pills-home",
      "aria-selected": _vm.activeTab === 'power'
    },
    on: {
      "click": function ($event) {
        return _vm.handleTabClick('power', 'POWER Curve');
      }
    }
  }, [_vm._v(" POWER ")])]), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "role": "presentation"
    }
  }, [_c('button', {
    staticClass: "nav-link",
    class: {
      active: _vm.activeTab === 'wkg'
    },
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "pills-profile-tab",
      "data-bs-toggle": "pill",
      "data-bs-target": "#pills-profile",
      "type": "button",
      "role": "tab",
      "aria-controls": "pills-profile",
      "aria-selected": _vm.activeTab === 'wkg'
    },
    on: {
      "click": function ($event) {
        _vm.handleTabClick('wkg', 'POWER CURVE (W/KG)');
      }
    }
  }, [_vm._v(" W/KG ")])])])])]), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "pills-tabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade",
    class: {
      'show active': _vm.activeTab === 'power'
    },
    attrs: {
      "id": "pills-home",
      "role": "tabpanel",
      "aria-labelledby": "pills-home-tab"
    }
  }, [_c('div', {
    staticClass: "graph-wrpr-box"
  }, [_vm.activeTab === 'power' ? _c('LineChartGenerator', {
    key: 'power-chart',
    attrs: {
      "chart-options": _vm.chartOptions,
      "chart-data": _vm.chartDataDefault
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "checkBoxes d-flex justify-content-center"
  }, [_vm._m(0), _vm.firstGraphDate ? _c('label', [_c('i', {
    staticClass: "fa-solid fa-circle txtClrlightRed"
  }), _vm._v(" " + _vm._s(_vm.firstGraphDate) + " ")]) : _vm._e(), _vm.secondGraphDate ? _c('label', [_c('i', {
    staticClass: "fa-solid fa-circle txtClrSkyBlue"
  }), _vm._v(" " + _vm._s(_vm.secondGraphDate) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "tab-pane fade",
    class: {
      'show active': _vm.activeTab === 'wkg'
    },
    attrs: {
      "id": "pills-profile",
      "role": "tabpanel",
      "aria-labelledby": "pills-profile-tab"
    }
  }, [_c('div', {
    staticClass: "graph-wrpr-box"
  }, [_vm.activeTab === 'wkg' ? _c('LineChartGenerator', {
    key: 'wkg-chart',
    attrs: {
      "chart-options": _vm.chartOptionsWeightPerKg,
      "chart-data": _vm.chartDataWeightPerKg
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "checkBoxes d-flex justify-content-center"
  }, [_vm._m(1), _vm.firstGraphDate ? _c('label', [_c('i', {
    staticClass: "fa-solid fa-circle txtClrlightRed"
  }), _vm._v(" " + _vm._s(_vm.firstGraphDate) + " ")]) : _vm._e(), _vm.secondGraphDate ? _c('label', [_c('i', {
    staticClass: "fa-solid fa-circle txtClrSkyBlue"
  }), _vm._v(" " + _vm._s(_vm.secondGraphDate) + " ")]) : _vm._e()])])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', [_c('i', {
    staticClass: "fa-solid fa-circle"
  }), _vm._v(" All TIME ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', [_c('i', {
    staticClass: "fa-solid fa-circle"
  }), _vm._v(" All TIME ")]);
}]

export { render, staticRenderFns }